export const AUTH_KEY = process.env.LOCAL_STORAGE_AUTH ?? "auth_dev";
export const BREAKPOINT_WIDTH = 767;

export const BASELINE_DATE = new Date("2020-01-01");

export const CLOUDINARY_DOMAIN = process.env.REACT_APP_CLOUDINARY_DOMAIN;
